import { render, staticRenderFns } from "./ChooseAddressModal.vue?vue&type=template&id=0712295e&scoped=true"
import script from "./ChooseAddressModal.vue?vue&type=script&lang=js"
export * from "./ChooseAddressModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseAddressModal.vue?vue&type=style&index=0&id=0712295e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712295e",
  null
  
)

export default component.exports